import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation updateUser($name: String, $phone: String, $id: Int!) {
    updateUser(name: $name, phone: $phone, id: $id) {
      id
      name
      phone
    }
  }
`;
